import mainApi from "./api.js";

function openAi(prompt) {
  return mainApi
    .getOpenAi(prompt)
    .then((answer) => {
      return answer; // Возвращаем результат из then
    })
    .catch((error) => {
      console.error("Ошибка при обновлении медиа URL:", error);
      throw error; // Пробрасываем ошибку, чтобы вызывающий код мог обработать её
    });
}

export default openAi;
